import { get } from 'lodash';
import { instance } from './api.service';
import { fileToBuffer } from '../../actions/utils';

export const getAppConfig = async () => {
  const resp = await instance.get(`/utils/config`, { data: {} });
  return get(resp, 'data.data', []);
};

// Returns the full payload: { data, meta } where meta holds lastSaved/savedBy.
export const getAppConfigFull = async () => {
  const resp = await instance.get(`/utils/config`, { data: {} });
  return get(resp, 'data', {});
};

// Returns { data, meta } — meta.lastSaved is updated by the server on save.
// baseLastSaved is the meta.lastSaved this page loaded its copy from; the
// server rejects with 409 if the config was saved again after that, so a
// stale tab can't silently overwrite someone else's changes.
export const saveAppConfig = async (data, baseLastSaved) => {
  const resp = await instance.post(`/utils/config`, { data, baseLastSaved });
  return get(resp, 'data', {});
};

// Returns [{ id, lastSaved, savedBy, before, after }], newest first.
export const getAppConfigHistory = async (limit = 50) => {
  const resp = await instance.get(`/utils/confighistory`, { params: { limit }, data: {} });
  return get(resp, 'data.history', []);
};

export const uploadFile = async (file) => {
  const buff = await fileToBuffer(file);
  const resp = await instance.post(`/utils/uploadfile`, { file: buff });
  return get(resp, 'data.result', {});
};